export default {
  namespaced: true,

  state: {
    isTestCall: false,
    callOngoing: false,
    currentAgentId: null,
    callStatus: "idle",
    liveTranscript: [],
    agentSpeaking: false,
    callError: null,
    voiceAgentConsentStatus: false,
  },

  mutations: {
    SET_TEST_CALL(state, isTestCall) {
      state.isTestCall = isTestCall;
    },

    SET_CALL_ONGOING(state, callOngoing) {
      state.callOngoing = callOngoing;
    },

    SET_CURRENT_AGENT_ID(state, agentId) {
      state.currentAgentId = agentId;
    },

    SET_CALL_STATUS(state, status) {
      state.callStatus = status;
    },

    SET_LIVE_TRANSCRIPT(state, transcript) {
      state.liveTranscript = transcript;
    },

    SET_AGENT_SPEAKING(state, speaking) {
      state.agentSpeaking = speaking;
    },

    SET_CALL_ERROR(state, error) {
      state.callError = error;
    },

    SET_VOICE_AGENT_CONSENT_STATUS(state, status) {
      state.voiceAgentConsentStatus = status;
    },

    RESET_CALL_STATE(state) {
      state.isTestCall = false;
      state.callOngoing = false;
      state.currentAgentId = null;
      state.callStatus = "idle";
      state.liveTranscript = [];
      state.agentSpeaking = false;
      state.callError = null;
    },
  },

  actions: {
    startTestCall({ commit }, agentId) {
      try {
        commit("SET_TEST_CALL", true);
        commit("SET_CURRENT_AGENT_ID", agentId);
        commit("SET_CALL_STATUS", "connecting");
        commit("SET_LIVE_TRANSCRIPT", []); 
      } catch (error) {
        console.error("Error starting test call:", error);
      }
    },

    setCallOngoing({ commit }, callOngoing) {
      commit("SET_CALL_ONGOING", callOngoing);
    },

    setCurrentAgentId({ commit }, agentId) {
      commit("SET_CURRENT_AGENT_ID", agentId);
    },

    setCallStatus({ commit }, status) {
      commit("SET_CALL_STATUS", status);
    },

    updateTranscript({ commit }, transcript) {
      commit("SET_LIVE_TRANSCRIPT", transcript);
    },

    appendTranscriptMessage({ commit, state }, message) {
      try {
        if (!message || !message.role || !message.content) {
          return;
        }
        const updatedTranscript = [...state.liveTranscript, message];
        const limitedTranscript = updatedTranscript.slice(-500);
        
        commit("SET_LIVE_TRANSCRIPT", limitedTranscript);
      } catch (error) {
        console.error("Error appending transcript message:", error);
      }
    },

    setAgentSpeaking({ commit }, speaking) {
      commit("SET_AGENT_SPEAKING", speaking);
    },

    setCallError({ commit }, error) {
      commit("SET_CALL_ERROR", error);
    },

    setVoiceAgentConsentStatus({ commit }, status) {
      commit("SET_VOICE_AGENT_CONSENT_STATUS", status);
    },

    endTestCall({ commit }) {
      commit("RESET_CALL_STATE");
    },
  },

  getters: {
    isTestCall: (state) => state.isTestCall,
    callOngoing: (state) => state.callOngoing,
    currentAgentId: (state) => state.currentAgentId,
    callStatus: (state) => state.callStatus,
    liveTranscript: (state) => state.liveTranscript,
    agentSpeaking: (state) => state.agentSpeaking,
    callError: (state) => state.callError,
    voiceAgentConsentStatus: (state) => state.voiceAgentConsentStatus,
  },
};


